<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          :color="color" 
          fab 
          dark 
          small
          v-on="on"
        >
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline grey lighten-2 py-0"
          primary-title
        >
          Novo Projeto
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn
              flat
              fab
              small
              icon
              @click="dialog = false"
              slot="activator"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-text-field 
            v-model="projeto.Projeto" 
            label="Descrição do projeto" 
            prepend-icon="description"
            id="add-desc-projeto"
            @keyup.enter="adiciona"
          ></v-text-field>
          <v-autocomplete
            v-model="projeto.TipoProjeto"
            :items="tiposProjetoAtivo"
            item-text="Descricao"
            return-object
            menu-props="auto"
            label="Tipo Projeto"
            hide-details
            prepend-icon="label_important"
            class="mb-3"
            no-data-text="Registro não encontrado"
            auto-select-first
            @change="changeTipoProjeto"
          ></v-autocomplete>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Projeto from '@/domain/projeto/Projeto';

export default {
  name: 'ModalCadastroProjeto',
  props: {
    icon: {
      type: String,
      default: 'add'
    },
    color: {
      type: String,
      default: 'primary'
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      projeto: new Projeto()
    }
  },
  watch: {
    dialog(newValue) {
      if (newValue) return this.$nextTick(() => document.getElementById('add-desc-projeto').focus());
    }
  },
  computed: {
    ...mapGetters(['colaboradores', 'tiposProjetoAtivo', 'situacoes'])
  },
  methods: {
    ...mapActions([
      'addProjeto',
      'fetchTiposProjeto'
    ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    changeTipoProjeto(obj) {
      this.projeto.TipoProjeto = obj.Descricao;
      this.projeto.IdTipoProjeto = obj.IdTipoProjeto;
    },
    async adiciona() {
      if (this.projeto.Projeto) {
        this.loading = true;
        // Guarda o último tipo de projeto selecionado no local storage para seleção automática ao criar projetos
        localStorage.setItem('idTipoProjeto', this.projeto.IdTipoProjeto);
        localStorage.setItem('tipoProjeto', this.projeto.TipoProjeto);
        try {
          const idProjeto = await this.addProjeto(this.projeto);
          this.loading = false;
          this.dialog = false;
          this.showNotification({ text: `Projeto: ${this.projeto.Projeto} adicionado com sucesso.`, status: 'success' });
          this.$router.push({ name: 'altera projeto', params: { id: idProjeto } });
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar o projeto: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Descrição do projeto.`, status: 'error' });
      }
    }
  },
  async created() {
    if (!this.tiposProjetoAtivo.length) {
      await this.fetchTiposProjeto();
    }

    if (localStorage.getItem('idTipoProjeto') !== null && localStorage.getItem('tipoProjeto') !== null) {
      this.projeto.IdTipoProjeto = parseInt(localStorage.getItem('idTipoProjeto'));
      this.projeto.TipoProjeto = localStorage.getItem('tipoProjeto');
    }
  }
}
</script>

<style>

</style>
